class CustomOptions extends HTMLElement {
    constructor() {
      super();
      this.debounceTimeout = null;
    }

    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('input'));

      this.inputs.forEach(input => input.addEventListener('input', this.inputChange.bind(this)));

      this.beforeBuy();
    }

    beforeBuy() {
      const productForm = document.querySelector('product-form form');
      if (!productForm) return;

      const submitButton = productForm.querySelector('button[type="submit"]');
      if (!submitButton) return;

      submitButton.disabled = !0;

      submitButton.addEventListener('click', (event) => {
        const result = this.checkValidate();
        if (!result) {
          event.stopPropagation();
          event.preventDefault();
        }

        event.target.disabled = !0;

        if (result) {
          event.target.disabled = !1;
        }
      });
    }

    inputChange(event) {
      event.stopPropagation();
      event.preventDefault();

      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const optionsData = this.getJsonData();
        const currentOptionData = optionsData.find(option => option.name === input.dataset.name);
        if (!currentOptionData) return;

        if (input.value === '' && input.required) {
          this.showErrorMessage(input, 'This is a required field');
          return;
        }

        if (input.value.length < currentOptionData.min) {
          this.showErrorMessage(input, `Please type at least ${currentOptionData.min} characters`);
          return;
        }

        if (input.value.length > currentOptionData.max) {
          this.showErrorMessage(input, `Please type at maximum ${currentOptionData.max} characters`);
          return;
        }

        this.showErrorMessage(input, '');
        const productForm = document.querySelector('product-form form');
        if (!productForm) return;

        const submitButton = productForm.querySelector('button[type="submit"]');
        if (!submitButton) return;

        submitButton.disabled = !1;
      }, 300);
    }

    checkValidate() {
      const optionsData = this.getJsonData();
      let bothIsValide = true;
      for (const input of this.inputs) {
        const currentOptionData = optionsData.find(option => option.name === input.dataset.name);
        if (!currentOptionData) {
          bothIsValide = false;
          this.showErrorMessage(input, 'Something wrong! Please contact us.');
          continue;
        }

        if (input.value === '' && input.required) {
          bothIsValide = false;
          this.showErrorMessage(input, 'This is a required field');
          continue;
        }

        if (input.value.length < currentOptionData.min) {
          bothIsValide = false;
          this.showErrorMessage(input, `Please type at least ${currentOptionData.min} characters`);
          continue;
        }

        if (input.value.length > currentOptionData.max) {
          bothIsValide = false;
          this.showErrorMessage(input, `Please type at maximum ${currentOptionData.max} characters`);
        }
      }

      return bothIsValide;
    }

    showErrorMessage(elem, msg) {
      const container = elem.closest('.tpo_option-container');
      if (!container) return;

      const msgBox = container.querySelector('.tpo_error-message');
      if (!msgBox) return;

      msgBox.textContent = msg;
    }

    getJsonData() {
      const jsonData = this.querySelector('script[type="application/json"]')?.textContent;
      return jsonData ? JSON.parse(jsonData) : [];
    }
  }

  customElements.define('custom-options', CustomOptions);